
import React from 'react';
import { trackPhoneCallConversion } from '@/utils/trackPhoneCall';

interface AddressType {
  street: string;
  city: string;
  postalCode: string;
}

interface LocationMapProps {
  locationName: string;
  address: AddressType;
  transportInfo: React.ReactNode;
  mapUrl: string;
  contactPhone: string;
  contactEmail: string;
}

const LocationMap = ({
  locationName,
  address,
  transportInfo,
  mapUrl,
  contactPhone,
  contactEmail
}: LocationMapProps) => {
  return (
    <section className="py-16 bg-gray-50">
      <div className="container mx-auto px-4">
        <div className="max-w-3xl mx-auto">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-serif font-bold mb-4">Find vej til undervisningen</h2>
            <p className="text-lg text-gray-600">
              Klaverundervisningen foregår på {address.street}, {address.postalCode} {address.city}, let tilgængeligt fra {locationName}.
            </p>
          </div>
          
          <div className="bg-white p-6 rounded-lg shadow-xl mb-10">
            <div className="overflow-hidden rounded-md">
              <iframe 
                src={mapUrl}
                width="100%" 
                height="450" 
                style={{ border: 0 }} 
                allowFullScreen={true} 
                loading="lazy" 
                referrerPolicy="no-referrer-when-downgrade"
                title="Lokation på kort">
              </iframe>
            </div>
          </div>
          
          <div className="bg-white p-6 rounded-lg shadow-xl">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
              <div className="space-y-4">
                <h3 className="text-xl font-serif font-semibold">Adresse</h3>
                <p className="text-gray-700">
                  {address.street}<br />
                  {address.postalCode} {address.city}
                </p>
                <div className="space-y-2">
                  <p className="text-gray-700"><strong>Transport fra {locationName}:</strong></p>
                  {transportInfo}
                </div>
              </div>
              <div className="space-y-4">
                <h3 className="text-xl font-serif font-semibold">Kontakt</h3>
                <p className="text-gray-700">
                  Telefon: <a href={`tel:${contactPhone}`} className="text-piano-gold hover:underline" onClick={trackPhoneCallConversion}>{contactPhone}</a>
                </p>
                <p className="text-gray-700">
                  Email: <a href={`mailto:${contactEmail}`} className="text-piano-gold hover:underline">{contactEmail}</a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default React.memo(LocationMap);
